import { Link } from "react-router-dom";
import "./PageNotFound.css";

// @name App
// @desc PageNotFound component would be visible on no routings got matched.
// @author Sahithi
export const PageNotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-text">
        <h1>404 Page Not Found</h1>
        <h3>Sorry, requested page is no longer available.</h3>
        {/*Add a Link component with the route to your home page */}
        <Link to="/">
          <button className="home-button">Go to Home Page</button>
        </Link>
      </div>
    </div>
  );
};
